// Markdown rendered in the browser for previews and freshly saved text, so nothing
// waits on a GitHub round trip. Existing posts show GitHub's own bodyHTML.
import DOMPurify from 'dompurify'
import { marked } from 'marked'
import { linkifyHtml } from './autolinks.js'

// GitHub issues and comments: GFM, single newlines become line breaks
marked.use({ gfm: true, breaks: true })

export function renderMarkdown(text) {
  return linkifyHtml(DOMPurify.sanitize(marked.parse(text || '')))
}

const TASK = /^(\s*(?:[-*+]|\d+[.)])\s+\[)([ xX])(\]\s+)(.*)$/
const FENCE = /^\s*(```|~~~)/

/** Task list items of a markdown text in document order (outside code blocks): { line, checked, text }. */
export function taskLines(text) {
  const tasks = []
  let fenced = false
  ;(text || '').split('\n').forEach((line, i) => {
    if (FENCE.test(line)) fenced = !fenced
    const match = !fenced && line.match(TASK)
    if (match)
      tasks.push({ line: i, checked: match[2] !== ' ', text: match[4].trim() })
  })
  return tasks
}

/** The text with one task checked off and the issue made from it linked: "- [x] text (see #12)". */
export function linkTask(text, task, number) {
  const lines = text.split('\n')
  lines[task.line] = lines[task.line].replace(
    TASK,
    (_, before, _check, after, rest) =>
      `${before}x${after}${rest.trimEnd()} (see #${number})`
  )
  return lines.join('\n')
}
